import Badge from '@components/Badge';
import CameraSelection from '@components/CameraSelection';
import PreviewVideo from '@components/PreviewVideo';
import QualitySelection from '@components/QualitySelection';
import { useVideoInputs } from '@providers/DevicesProvider';
import type { FC } from 'react';
import {
  Container,
  DeviceControlArea,
  DeviceInfo,
  DeviceName,
  DeviceSplitLeft,
  DeviceSplitRight,
  DeviceStatusArea,
} from './style';

const Camera: FC = () => {
  const { selectedDevice } = useVideoInputs();
  const isSelectedDevice = selectedDevice !== undefined;

  return (
    <Container>
      <DeviceSplitLeft>
        <DeviceInfo>
          <DeviceStatusArea>
            <DeviceName>카메라</DeviceName>
            <Badge type={isSelectedDevice ? 'success' : 'fail'}>
              {isSelectedDevice ? '완료' : '대기중'}
            </Badge>
          </DeviceStatusArea>
          <DeviceControlArea>
            <CameraSelection />
          </DeviceControlArea>
        </DeviceInfo>
        <DeviceInfo>
          <DeviceStatusArea>
            <DeviceName>화질</DeviceName>
          </DeviceStatusArea>
          <DeviceControlArea>
            <QualitySelection />
          </DeviceControlArea>
        </DeviceInfo>
      </DeviceSplitLeft>
      <DeviceSplitRight>
        <PreviewVideo />
      </DeviceSplitRight>
    </Container>
  );
};

export default Camera;
